<template>
  <div id="consulta d-flex flex-row flex-wrap justify-content-center">
    <Header :totem="totem" />
    <b-modal ref="modalBoleto" size="xl" scrollable title="Consulte seu Boleto / Relatório" id="modal-dialog">
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Boleto" active>
            <object width="100%" height="500" type="application/pdf" :data=this.pdf_boleto>
            </object>
          </b-tab>
          <b-tab title="Relatório"><object width="100%" height="500" type="application/pdf" :data=this.pdf_Relatorio>
            </object></b-tab>
        </b-tabs>
      </div>
    </b-modal>

    <div id="wrapper-spinner" v-if="loading"
      style="display: block;position: absolute;background: #aaa0a08f;z-index: 100;width: 100%;height: 100%;padding-top: 25%;padding-left: 50%;">
      <BeatLoader color="var(--main-azul)" />
    </div>

    <div id="consulta-form" class="w-100">
      <div class="card text-cernter card-form">
        <div class="card-body">
          <h3 class="text-center mb-5"><b>Pagamento de Emolumentos</b></h3>
          <label id="label-infolet" for="input-live"> Digite a Chave</label>
          <span v-b-popover.hover.top="'Digite atentamente sua chave!.'" title="Chave">
            <b-form-input id="input-live" class="mb-4" size="lg" v-model="chave" placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
            trim></b-form-input>
          </span>
          <b-row>
            <b-col sm="6" class="mb-2">
              <b-button class="btn-gerar-pdf" @click="gerarBoleto()"><font-awesome-icon size="2x" icon="file-pdf" /><span>Gerar Boleto/PDF</span></b-button>
            </b-col>
            <b-col sm="6" class="mb-2">
              <b-button class="btn-exportar-busca" @click="gerarxls()">
                <img src="~@/assets/imgs/icons/xlsx_logo.svg" /><span>Exportar Relatório</span>
              </b-button>
            </b-col>
          </b-row>
          <h4 class="text-center" style="margin: 25px auto 0 auto;"><b>Olá!</b> Copie a chave recebida por e-mail e tenha acesso ao boleto para o pagamento</h4>
        </div>
      </div>
    </div>

    <vue-recaptcha ref="invisibleRecaptcha" @verify="onVerify" @expired="onExpired" size="invisible"
      :sitekey="sitekey"></vue-recaptcha>
    
    <vue-recaptcha ref="captchaInvisible" @verify="verifyXls" @expired="expiredXls" size="invisible"
      :sitekey="sitekey"></vue-recaptcha>
    <footersite class="d-none d-xl-block" v-if="!totem" />
    <footersitemobile class="d-block d-xl-none" v-if="!totem" />
  </div>
</template>

<script>
import API from "../services/api";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import VueRecaptcha from "vue-recaptcha";
import Header from '../components/Header';
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";


export default {
  props: ['totem'],
  components: {
    BeatLoader,
    VueRecaptcha,
    Header,
    footersite,
    footersitemobile,
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
      chave: "",
      tok: "",
      loading: false,
      pdf_boleto: "",
      pdf_Relatorio: ""
    };
  },
  mounted() {},
  methods: {
    onVerify: function (response) {
      this.tok = response;
      this.$refs.invisibleRecaptcha.reset();
      if (this.chave) {
        this.loading = true;
        API.get(`/pesquisa/boleto_UUID/${this.chave}/${this.tok}`)
          .then(res => {
            if (res.data.result == 1) {
              this.pdf_boleto = res.data.boleto[0].ds_endereco_boleto;
              this.pdf_Relatorio = "data:application/pdf;base64, " +
                encodeURI(res.data.boleto[0].relatorio);
              this.loading = false;
              this.$refs["modalBoleto"].show();
              this.$refs["modalRelatorio"].show();
            } else {
              alert('Boleto não encontrado! Verifique sua chave')
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
        this.chave = '';
      }
      this.resetRecaptcha();
    },
    onExpired: function () {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
    },
    gerarBoleto() {
      this.$refs.invisibleRecaptcha.execute();
    },
    verifyXls: function (response) {
      this.token = response;
      this.$refs.captchaInvisible.reset();
      if (this.chave) {
        this.loading = true;
        API.get(`/pesquisaxls/boleto_UUID/${this.chave}/${this.token}`, { responseType: 'blob' })
          .then(result => {
            console.log(result)
            const blob = new Blob([result.data], { type: 'application/vnd.ms-excel' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            const lastElement = url.split('/').pop(); 
            const filename = 'boleto-' + lastElement + '.xls';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);
          })
          .catch(error => {
            alert('Boleto não encontrado! Verifique sua chave')
            this.loading = false
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
        this.chave = '';
      }
      this.resetCaptchaXls()
    },

    expiredXls() {
      this.$refs.captchaInvisible.reset()
    },
    resetCaptchaXls() {
      this.$refs.captchaInvisible.reset()
    },
    gerarxls() {
      this.$refs.captchaInvisible.execute()
    }
  }
};
</script>

<style scoped>


#rodape {
  background-color: #185684;
  width: 100%;
  height: 145px;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0;
}

html {
  overflow: hidden !important;
}

#logo-header {
  width: 300px;
}

.icone {
  font-size: 16px;
  margin-top: 10px;
}
#consulta-form{margin-top: 120px;background: #fbfbfd;height: calc(100vh - 120px - 37px) !important;padding: 0px 17px;align-items: center; display: flex;}
#consulta-form .card-form{max-width: 650px; min-width: 315px;margin: 0 auto;padding:40px; box-shadow: 17px 20px 40px rgba(0,0,0,.21); -webkit-box-orient: vertical; -webkit-box-direction: normal;border-radius: 16px;border:none;}
h3 {
  font: normal normal bold 30px/30px 'Kanit', sans-serif;
  letter-spacing: -2.8px;
  text-rendering:optimizeLegibility;
}
h4 {
  font: normal normal normal 22px/25px 'Kanit', sans-serif;
  letter-spacing: 0;
  text-rendering:optimizeLegibility;
  max-width: 300px;
}
#label-infolet{
  position: absolute;
  font-size: 12px;
  line-height: 1.33337;
  font-weight: 400;
  letter-spacing: -.01em;
  margin-top: .3rem;
  color: #6e6e73 !important;
  pointer-events: none;
  margin-left: 17px;
}
input {
  background-color: hsla(0,0%,100%,.8);
  height: 58px;
  border-color: #86868b;
  font-size: 17px;
  line-height: 1.23536;
  font-weight: 400;
  letter-spacing: -.022em;
  width: 100%;
  height: 3.29412rem;
  border-radius: 12px;
  box-sizing: border-box;
  color: #494949;
  border: 1px solid;
  border-radius: 12px;
  margin-bottom: .82353rem;
  padding: 1.05882rem .94118rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 530px;
}
button {
  display: flex;
  align-items: center;
  width: fit-content;
  height: 52px;
  border-radius: 5px;
  letter-spacing: -.022;
  opacity: 1;
  font: normal normal bold 17px/18px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #ffffff;
  border: none;
  min-width: 213px;
  justify-content: space-between;
  width: 100%;

}
button svg{font-size: 25px;}
button img{height: 30px;}
button span{text-align: center;width: 100%;}
button.btn-gerar-pdf {background: #B30B00 0% 0% no-repeat padding-box;float: left;}
  button.btn-gerar-pdf:active,
  button.btn-gerar-pdf:hover{background: #6b0902 0% 0% no-repeat padding-box;}
button.btn-exportar-busca {background: #1ACEB5 0% 0% no-repeat padding-box;float: right;}
  button.btn-exportar-busca:active,
  button.btn-exportar-busca:hover{background: #00733b 0% 0% no-repeat padding-box;}
@media (max-width: 1199px) {
    #consulta-form{margin-top: 68px;height: fit-content;}
  }
  @media (max-width: 525px) {
    #consulta-form .card-form{padding: 40px 20px;}
    #consulta-form .card-form .card-body{padding: 0px;}
  }
</style>
